// removed by extract-text-webpack-plugin
module.exports = {"subscriptionCell":"_3mZml1ijZqH5ajGgfrmhRL","name":"_3fKeKwvr2QVonhckWVF0mZ","mobileName":"o3PZGvCSY0eV3hYyKP9nS","toggleStatus":"_1L1wPxpqpEjUaM3onRty2u"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SubscriptionCell/SubscriptionCell.scss
// module id = 1757
// module chunks = 0